import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CnpjValidator {

  /**
   * Valida um CNPJ.
   *
   * @param cnpj Valor do CNPJ a ser validado.
   * @return boolean Informando se o CNPJ é válido ou não.
   */
  private static cnpjValido(cnpj: string): boolean {
    if (cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      const cnpjsInvsRegex = /1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14}|0{14}/;

      if (!cnpj || cnpj.length !== 14 || cnpjsInvsRegex.test(cnpj)) {
        return false;
      }

      var tamanho = cnpj.length - 2;
      var numeros = cnpj.substring(0, tamanho);
      var digitos = cnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;

      for (var i: number = tamanho; i >= 1; i--) {
        soma += +numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }

      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== parseInt(digitos.charAt(0), 10)) {
        return false;
      }

      tamanho += 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;

      for (i = tamanho; i >= 1; i--) {
        soma += +numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }

      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

      return (resultado === parseInt(digitos.charAt(1), 10));
    }

    return true;
  }


  /**
   * Método estático responsável pela validação dos dados do CNPJ.
   *
   * @param control Control do formulário Angular que contém o valor do CNPJ.
   * @return object ou null caso o CNPJ seja válido.
   */
  static validate(control: AbstractControl): ValidationErrors {
    const cnpj = control.value;
    return this.cnpjValido(cnpj) ? {} : { invalid_cnpj: true };
  }
}
